import { isIncomingSuperlikeCard } from '@entities/superlike/ui';

import { type FeedResponse } from '@services/FeedService';
import { type IncomingSuperlikeCard } from '@services/SuperlikesService';

/**
 * Puts the received superlikes at the front of the deck (plan §2, review
 * S8/B5). Each card gets `liked_me: true`: a delivered superlike is a like,
 * so a like back is a match. A sender the deck already shows with its
 * superlike stays where it is, so a refresh never reorders the deck; a
 * sender the deck holds as a plain feed card moves to the front with it.
 * The front cards live in the deck and count as held (each costs a swipe).
 */
export const mergeIncomingSuperlikes = (
  deck: FeedResponse[],
  incoming: IncomingSuperlikeCard[],
) => {
  const shownIds = new Set(
    deck.flatMap((item) =>
      'id' in item && isIncomingSuperlikeCard(item) ? [item.id] : [],
    ),
  );
  const front = incoming
    .filter(
      (card, index) =>
        !shownIds.has(card.id) &&
        incoming.findIndex((each) => each.id === card.id) === index,
    )
    .map((card) => ({ ...card, liked_me: true }));

  if (front.length === 0) {
    return { deck, added: 0 };
  }

  const frontIds = new Set(front.map((card) => card.id));

  return {
    deck: [
      ...front,
      ...deck.filter((item) => !('id' in item) || !frontIds.has(item.id)),
    ],
    added: front.length,
  };
};
